// extracted by mini-css-extract-plugin
export default {"main":"Login_main__cyalP","formBox":"Login_formBox__8wFlP","formValue":"Login_formValue__7hj2k","form":"Login_form__lOo5H","btnSubmit":"Login_btnSubmit__Nlf3M"};